import { render, staticRenderFns } from "./updateBulkPromotion.vue?vue&type=template&id=1f9a11d0&scoped=true&"
import script from "./updateBulkPromotion.vue?vue&type=script&lang=js&"
export * from "./updateBulkPromotion.vue?vue&type=script&lang=js&"
import style0 from "./updateBulkPromotion.vue?vue&type=style&index=0&id=1f9a11d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a11d0",
  null
  
)

export default component.exports